import gql from 'graphql-tag'

export const GET_SERVICE_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getServicePaginated(
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleKg
        titleRu
        categoryEn
        categoryKg
        categoryRu
        aboutId
        homeId
      }
    }
  }
`

export const GET_SERVICE_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getService (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleKg
      titleRu
      categoryEn
      categoryKg
      categoryRu
      descriptionEn
      descriptionKg
      descriptionRu
      tagsEn
      tagsKg
      tagsRu
      aboutId
      homeId
      icon
      image
      isWhyWe
    }
  }
`
